export enum ChangeType {
  OPTIONAL = 'optional',
  CANCELED = 'cancelled',
  SPECIAL = 'special',
  QUANTITY_INCREASE = 'quantity_increase',
  QUANTITY_DECREASE = 'quantity_decrease',
  MODIFICATION = 'modification',
  MATERIAL = 'material'
}
